export default "https://cdn-static.gokick.com/assets/0205635f2685a00e1fdcb9112c4ac213a84703ca/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";